<style lang="stylus" scoped>

    $borderColor = lighten(#e5e5e5, 20%)
    $navHeight = 54px
    $color = #777
    .nav-link
        padding: 0 15px
        display: inline-block
        font-size: 16px
        height: $navHeight
        line-height: $navHeight
        color: #26292a
        position relative
        transition-property: background-color
        transition-duration: 0.3s
        & + .nav-dropmenu
            position absolute
            display block
            background-color #FFF
            width 200px
            left -100px + 31px
            z-index 10
            border-radius 2px
            box-shadow 0 6px 12px 3px rgba(0, 0, 0, .175)
            li
                display inline-block
                width 50%
                a
                    color $color
                    text-align center
                    display block
                    padding 10px 5px
                    &:hover
                        color #009ee7
                    i
                        display block
                        font-size 1.5em
                        margin-bottom 5px

    .nav-link:hover
        color: #009ee7
        background-color: transparent

    .navbar-nav > li
        float: left
        position relative

    a.active
        color: #009ee7
        border-bottom: 3px solid #009ee7

    .dropdown-toggle-hover
        &:hover
            .nav-link
                color: #009ee7
        .dropdown-menu
            width 120px
            min-width @width
            transform translateX(-30px)
            .fa
                margin 0 5px
    .store-block
        height: 30px
        line-height 30px
        color: #ff7800
        border: 0px
        background-color: #f3f5f9
        padding: 0 10px
        border-radius: 3px
    .mr5
        margin-right: 5px
    .py10 {
        padding: 10px 0 !important
    }

</style>

<template>
    <ul class="nav navbar-nav">
        <template v-for="nav in navs">
            <li>
                <div v-if="!env.isCompanyDomain && isStore(nav)"
                     @mouseenter="showResourceMenu=true"
                     @mouseleave="showResourceMenu=false"
                     class="btn-group">
                    <a class="nav-link nav-ldown-topdown-toggle"
                       :class="{'active': nav.pageType === currentPageType}"
                    >
                        商店 <span class="caret"></span>
                    </a>
                    <ul class="nav-dropmenu" v-show="showResourceMenu" transition="menu">
                        <li v-for="item in resourceMenu">
                            <a :href="getMenuUrl(item.id)">
                                <i :class="item.icon"></i>{{item.title}}
                            </a>
                        </li>
                    </ul>
                </div>

                <a v-else
                   class="nav-link"
                   :target="nav.target || ''"
                   :href="nav.href"
                   v-text="nav.text"
                   :class="{'active': nav.pageType === currentPageType}"
                ></a>
            </li>
        </template>
        <li v-if="!env.isCompanyDomain && isLogin && !_isShowType() ">
            <a class="py10" :href="storeHref()" target="_blank">
                <div class="store-block" v-if="!isEmployee()">
                    <i class="fa fa-book mr5"></i>购买题库
                </div>
                <div class="store-block" v-if="isEmployee()">
                    <i class="fa fa-pencil mr5"></i>购买练习
                </div>
            </a>
        </li>
    </ul>
</template>

<script lang="babel">
    import { params, request } from 'bootsets/runtime'
    import { getCurrentNavs } from './navbar-util'
    import { PageType, ResType, PurchaseType, EmployerType } from 'core/constant'
    import { addUrlParams } from 'bootsets/utils'
    export default{
        data() {
            return {
                showResourceMenu: false,
                resourceMenu: [ {
                    id: 0,
                    icon: 'fa fa-book',
                    title: '我要买题'
                }, {
                    id: 1,
                    icon: 'fa fa-pencil',
                    title: '我要练习'
                } ],
                currentPageType: +params.pageType || +request.pageType || '',
                // 导航
                navs: [],
                env: window.SETS.env,
                isLogin: window.SETS.user.login,
                employerType: window.SETS.user.employerType
            }
        },
        methods: {
            isStore(nav) {
                return nav.pageType === PageType.STORE
            },
            getMenuUrl(type){
                return type ? this.employeeStoreUrl : this.employerStoreUrl
            },
            _isShowType(){
                const currentType = +params.pageType || +request.pageType || ''
                return currentType === PageType.HOME ||
                        currentType === PageType.STORE ||
                        currentType === PageType.STORE_101TEST ||
                        currentType === PageType.HELP ||
                        window.showBlackBar
            },
            storeHref() {
                if (this.employerType === EmployerType.EXAMINEE) {
                    return `/store/open/resource?test101=1&resType=${ResType.PAPER}`
                } else {
                    return `/store/open/resource?test101=1&resType=${ResType.QUESTION_BANK}`
                }
            },
            isEmployee() {
                return this.employerType === EmployerType.EXAMINEE
            }
        },
        ready() {
            this.navs = getCurrentNavs()
        },
        computed: {
            employerStoreUrl() {
                return addUrlParams('/store/open/resource', {
                    resType: ResType.QUESTION_BANK
                })
            },
            employeeStoreUrl() {
                return addUrlParams('/store/open/resource', {
                    resType: ResType.PAPER,
                    purchaseType: PurchaseType.TEST
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// navbar.vue?6d0c8c8d